/**
 * Computes a suffix for a form label based on its position within a dynamic row group.
 *
 * @param {WidgetProps<any>} props - The widget props, which may include dynamic row and label suffix settings.
 * @returns {string | undefined} A string containing the row index suffix (e.g., " 1") or `undefined` if not applicable.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getFormLabelSuffix(props) {
    var _a;
    if (!((_a = props.config) === null || _a === void 0 ? void 0 : _a.appendRowIndexToLabel)) {
        return undefined;
    }
    const getRootParentDynamicRow = (props) => {
        if (props && !props.parentDynamicRow) {
            return getRootParentDynamicRow(props.parentProps);
        }
        return props === null || props === void 0 ? void 0 : props.parentDynamicRow;
    };
    const rootParentDynamicRow = getRootParentDynamicRow(props);
    return (rootParentDynamicRow === null || rootParentDynamicRow === void 0 ? void 0 : rootParentDynamicRow.index) !== undefined ? ' ' + ((rootParentDynamicRow === null || rootParentDynamicRow === void 0 ? void 0 : rootParentDynamicRow.index) + 1) : undefined;
}
